import { QueryDocumentSnapshot, snapToData } from '@angular/fire/firestore';
import { FormControl, FormGroup } from "@angular/forms";
import { PackageType } from "../enums/package-type.enum";

export type PackagingForm = FormGroup<{
  id: FormControl<string>;
  description: FormControl<string>;
  organizationId: FormControl<string>;
  type: FormControl<PackageType>;
  width: FormControl<number>;
  height: FormControl<number>;
  length: FormControl<number>;
  price: FormControl<number>;
  weight: FormControl<number>;
}>

export class Packaging {
  id: string;
  description: string;
  organizationId: string;
  type: PackageType;
  width: number;
  height: number;
  length: number;
  price: number;
  weight: number;

  constructor(data?: Partial<Packaging>) {
    this.id = data?.id ?? '';
    this.description = data?.description ?? '';
    this.organizationId = data?.organizationId ?? '';
    this.type = data?.type ?? PackageType.PACKAGE;
    this.width = data?.width ?? 0;
    this.height = data?.height ?? 0;
    this.length = data?.length ?? 0;
    this.price = data?.price ?? 0;
    this.weight = data?.weight ?? 0;
  }

  static toFirestore(packaging: Packaging): Packaging {
    return {
      id: packaging.id,
      description: packaging.description,
      organizationId: packaging.organizationId,
      type: packaging.type,
      width: packaging.width,
      height: packaging.height,
      length: packaging.length,
      price: packaging.price,
      weight: packaging.weight,
    };
  }

  static fromFirestore(snapshot: QueryDocumentSnapshot): Packaging {
    return new Packaging(snapToData(snapshot, { idField: 'id' }));
  }
}
